import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  initCouponInfo,
  requestCouponStart,
  requestCouponSuccess,
  requestCouponFail,

  requestCouponHistoryStart,
  requestCouponHistorySuccess,
  requestCouponHistoryFail,

  requestCouponDetailStart,
  requestCouponDetailSuccess,
  requestCouponDetailFail,

  importMasterCouponStart,
  importMasterCouponSuccess,
  importMasterCouponFail,

} from '../actions/coupons';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_IMPORT } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* requestCoupon({ payload }) {

  // console.log('[sages] requestCoupon : ', payload);

  const apiURL = `${url}/backend/v1/coupon`;

  //====================================================================================================================

  try {
    const data = yield method_GET({ url: apiURL, params: payload?.params });

    /*console.log("[API] GET : ",);*/

    yield put(requestCouponSuccess(data));

  } catch (error) {
    yield put(requestCouponFail(error));
  }

  //====================================================================================================================

}

export function* requestCouponHistory({ payload }) {

  console.log('[sages] requestCouponHistory : ', payload);

  const apiURL = `${url}/backend/v1/import/${payload?.type}`;

  //====================================================================================================================

  try {
    const data = yield method_GET({ url: apiURL, params: payload?.params });

    /*console.log("[API] GET : ",);*/

    yield put(requestCouponHistorySuccess(data));

  } catch (error) {
    yield put(requestCouponHistoryFail(error));
  }

  //====================================================================================================================

}

export function* requestCouponDetail({ payload }) {

  console.log('[sages] requestCouponDetail : ', payload);

  const apiURL = `${url}/backend/v1/coupon/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_GET({ url: apiURL, params: payload?.params });

    // console.log('[sages] requestCouponDetail : ', data);

    yield put(requestCouponDetailSuccess(data));

  } catch (error) {
    yield put(requestCouponDetailFail(error));
  }

  //====================================================================================================================

}

export function* importMasterCoupon({ payload = {} }) {

  console.log('[sages] importMasterCoupon 1 : ', payload);

  const apiURL = `${url}/backend/v1/import/${payload?.type}`;

  const formData = new FormData();
  formData.append('file', payload.file);

  //====================================================================================================================

  try {
    const data = yield method_IMPORT(
      {
        url: apiURL,
        data: formData
      }
    );

    console.log('[sages] importMasterCoupon: 2 ', data);

    yield put(importMasterCouponSuccess(data));

  } catch (error) {

    console.log('[sages] importMasterCoupon: 3 [error]', { error });
    yield put(importMasterCouponFail(error));
  }

  //====================================================================================================================
}

export function* watchCoupon() {

  /*console.log('[sages] watchCoupon : ✅');*/

  yield all([
    takeLatest(requestCouponStart, requestCoupon),
    takeLatest(requestCouponHistoryStart, requestCouponHistory),
    takeLatest(requestCouponDetailStart, requestCouponDetail),
    takeLatest(importMasterCouponStart, importMasterCoupon),
  ])
}



